import Loading from "../../../components/Loading/Loading";
import ErrorList from "../../../components/ErrorList/ErrorList";
import React, { useContext, useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { UserContext } from "../../../contexts/AdminUserContext";

export default function UpdateEmployee() {
    const { user } = useContext(AuthContext);
    const { fetchEmployees } = useContext(UserContext);
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const navigate = useNavigate();
    const [employee, setEmployee] = useState({
        id: 0,
        name: "",
        email: "",
        phoneNumber: "",
        address: "",
        dateOfBirth: "",
        gender: true,
        newPassword: "",
        isEmailVerified: false,
        createdAt: "",
        imageUrl: "",
        updateAt: "",
        status: ""
    });
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;
        if (name === "gender") {
            newValue = value === "1";
        }
        setEmployee((prev) => ({
            ...prev,
            [name]: newValue
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!id || parseInt(id) <= 0) {
            setErrors(["ID nhân viên không hợp lệ."]);
            return;
        }
        if (!user || !user.token) {
            setErrors(["Không tìm thấy token xác thực. Vui lòng đăng nhập lại."]);
            return;
        }
        if (!employee.name || !employee.email) {
            setErrors(["Vui lòng điền đầy đủ họ tên và email."]);
            return;
        }
        if (!employee.newPassword) {
            setErrors(["Vui lòng cập nhật mật khẩu mới hoặc sử dụng mật khẩu cũ."]);
            return;
        }
        setLoading(true);
        try {
            const payload = {
                id: parseInt(id),
                name: employee.name,
                email: employee.email,
                phoneNumber: employee.phoneNumber,
                address: employee.address,
                dateOfBirth: employee.dateOfBirth,
                gender: employee.gender,
                newPassword: employee.newPassword || null,
                status: employee.status
            };
            console.log("Payload being sent:", payload);
            const response = await axios.put(
                `/api/User/update-employee`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            setEmployee(response.data);
            setErrors([]);
            await fetchEmployees(); // Refresh employee list
            navigate("/manager/employees"); // Redirect to employees page
        } catch (error) {
            console.error("Lỗi khi cập nhật nhân viên:", error);
            if (error.response && error.response.data) {
                console.log("Server response:", error.response.data);
                const { message, errors } = error.response.data;
                if (errors && typeof errors === "object") {
                    setErrors(Object.values(errors));
                } else {
                    setErrors(Array.isArray(errors) ? errors : [message || "Có lỗi xảy ra. Vui lòng thử lại sau."]);
                }
            } else {
                setErrors(["Có lỗi xảy ra. Vui lòng thử lại sau."]);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchEmployee = async () => {
            if (!id) {
                setErrors(["ID nhân viên không hợp lệ."]);
                return;
            }
            if (!user || !user.token) {
                setErrors(["Không tìm thấy token xác thực. Vui lòng đăng nhập lại."]);
                return;
            }
            setLoading(true);
            try {
                const response = await axios.get(`/api/User/get-employee-by-id/${id}`, {
                    headers: {
                        Authorization: `Bearer ${user.token}`
                    }
                });
                setEmployee({
                    ...response.data,
                    newPassword: ""
                });
                setErrors([]);
            } catch (error) {
                console.error("Lỗi khi lấy dữ liệu nhân viên:", error);
                if (error.response && error.response.data) {
                    const { message, errors } = error.response.data;
                    setErrors(Array.isArray(errors) ? errors : [message || "Không thể lấy dữ liệu nhân viên"]);
                } else {
                    setErrors(["Không thể lấy dữ liệu nhân viên"]);
                }
            } finally {
                setLoading(false);
            }
        };
        if (id) {
            fetchEmployee();
        }
    }, [id, user]);

    return (
        <div className="container mx-auto p-4">
            <Loading isLoading={loading} />
            <ErrorList errors={errors} />
            <div className="bg-white shadow-md rounded-lg p-6">
                <h2 className="text-2xl font-bold mb-4">Cập nhật thông tin nhân viên</h2>
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Họ và Tên</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={employee.name}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={employee.email}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="phoneNumber" className="block text-sm font-medium text-gray-700">Số điện thoại</label>
                            <input
                                type="text"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={employee.phoneNumber}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="address" className="block text-sm font-medium text-gray-700">Địa chỉ</label>
                            <input
                                type="text"
                                id="address"
                                name="address"
                                value={employee.address}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">Sinh nhật</label>
                            <input
                                type="date"
                                id="dateOfBirth"
                                name="dateOfBirth"
                                value={employee.dateOfBirth}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="gender" className="block text-sm font-medium text-gray-700">Giới tính</label>
                            <select
                                id="gender"
                                name="gender"
                                value={employee.gender ? "1" : "0"}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            >
                                <option value="1">Nam</option>
                                <option value="0">Nữ</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">Mật khẩu mới</label>
                            <input
                                type="password"
                                id="newPassword"
                                name="newPassword"
                                value={employee.newPassword}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="status" className="block text-sm font-medium text-gray-700">Trạng thái</label>
                            <select
                                id="status"
                                name="status"
                                value={employee.status}
                                onChange={handleChange}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            >
                                <option value="Active">Hoạt động</option>
                                <option value="InActive">Dừng hoạt động</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="isEmailVerified" className="block text-sm font-medium text-gray-700">Xác minh Email</label>
                            <input
                                type="text"
                                id="isEmailVerified"
                                name="isEmailVerified"
                                disabled
                                value={employee.isEmailVerified ? "Có" : "Không"}
                                readOnly
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-gray-200 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="createdAt" className="block text-sm font-medium text-gray-700">Được tạo lúc</label>
                            <input
                                type="text"
                                id="createdAt"
                                name="createdAt"
                                disabled
                                value={employee.createdAt ? new Date(employee.createdAt).toLocaleString() : "N/A"}
                                readOnly
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-gray-200 sm:text-sm"
                            />
                        </div>
                        <div>
                            <label htmlFor="updateAt" className="block text-sm font-medium text-gray-700">Cập nhật lúc</label>
                            <input
                                type="text"
                                id="updateAt"
                                name="updateAt"
                                disabled
                                value={employee.updateAt ? new Date(employee.updateAt).toLocaleString() : "N/A"}
                                readOnly
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 bg-gray-200 sm:text-sm"
                            />
                        </div>
                    </div>
                    <div className="mt-6">
                        <button
                            type="submit"
                            className="bg-blue-600 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                        >
                            Lưu
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}